import React from 'react';

export default function ClubDetails({club, style}) {
  console.debug("ClubDetails", club);
  return (
    <article className='ClubDetails' style={style}>
      <h2>Mon Club</h2>
      <figure>
        {club.imgUrl && <img src={club.imgUrl} alt={club.name}/>}
      </figure>
      <section>
        <h3>{club.name}</h3>
        <p className="ClubDetailsAddress">
          <span className="title">Localisation</span>
          <span>{club.address}</span>
          {!!club.address2 &&
            <span>{club.address2}</span>
          }
          <span>{`${club.zip} ${club.city}`}</span>
        </p>
        <p className="ClubDetailsPhone">
          <span className="title">Téléphone</span>
          <span>{club.phone}</span>
        </p>
        <p className="ClubDetailsEmail">
          <span className="title">Email</span>
          <span>{club.notifyMail[0]}</span>
        </p>
        <p className="ClubDetailsOpeningHours">
          <span>{club.opening_hours}</span>
        </p>
      </section>
    </article>
  );
}
